import { SupportedLocaleEnum } from '@vetahealth/tuna-can-api'
import { LocalStorageKey, Tokens } from './types'

export const storage = {
  getTokens: (): Tokens | undefined => {
    const tokens = localStorage.getItem(LocalStorageKey.tokens)
    if (tokens) return JSON.parse(tokens)
  },
  updateTokens: (tokens: Tokens): void => {
    localStorage.setItem(LocalStorageKey.tokens, JSON.stringify(tokens))
  },
  deleteTokens: (): void => {
    localStorage.removeItem(LocalStorageKey.tokens)
  },
  getLocale: (): SupportedLocaleEnum | undefined => {
    const locale = localStorage.getItem(LocalStorageKey.locale)
    if (locale) return locale as SupportedLocaleEnum
  },
  updateLocale: (locale: SupportedLocaleEnum): void => {
    localStorage.setItem(LocalStorageKey.locale, locale)
  },
}
